export enum UserProfileLinkRel {
	EDIT = 'edit',
}
